import { resources as commonTranslations } from "@evergis/common";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import ru from "./ru.json";

const resources = {
  en: {
    translations: en,
    ...commonTranslations.en,
  },
  ru: {
    translations: ru,
    ...commonTranslations.ru,
  },
} as const;

type Language = keyof typeof resources;

const isLanguage = (lng?: string): lng is Language => !!lng && Object.keys(resources).includes(lng);

const envLanguage = process.env.FIXED_LANGUAGE;

export const DEFAULT_LANGUAGE: Language = "ru";

const FIXED_LANGUAGE: Language | undefined = isLanguage(envLanguage) ? envLanguage : undefined;

const FIXED_LANGUAGE_COOKIE = "evergis_fixed_language";

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: FIXED_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    ns: Object.keys(resources[DEFAULT_LANGUAGE]),
    interpolation: {
      escapeValue: false,
    },
    resources,
    supportedLngs: Object.keys(resources),
    detection: { caches: FIXED_LANGUAGE ? [] : ["localStorage"] },
  });

if (!i18n.language) {
  i18n.changeLanguage(DEFAULT_LANGUAGE);
}

if (typeof document !== "undefined") {
  document.cookie = FIXED_LANGUAGE
    ? `${FIXED_LANGUAGE_COOKIE}=${FIXED_LANGUAGE}; path=/; max-age=31536000`
    : `${FIXED_LANGUAGE_COOKIE}=; path=/; max-age=0`;
}

export { i18n };
